<template lang="html">
  <div class="px-2 md:px-24">
    <div type="none" class="md:block pt-16">
      <div class="flex pt-4">
        <div class="w-full pt-10">
          <h1 class="hidden md:block font-bold text-3xl text-gray-800">
            {{ 'Loan Application' }}
          </h1>
        </div>
      </div>
    </div>
    <div class="block pb-4">
      <!-- todo: add the progressbar back here? -->
      <!-- <base-progress
        class="mb-0 md:block hidden"
        :showLabel="true"
        :striped="false"
        :animated="false"
        :height="12"
        :type="['warning', 'teal', 'teal', 'secondary', 'primary', 'primary', 'yellow'][1]"
        :value="this.pageProgress[this.$store.state.applicationData.step]"
        v-if="this.$store.state.applicationData.step !== 'rejected'"
      >
      </base-progress> -->
    </div>
    <div class="row">
      <div class="col">
        <div class="card-wrapper">
          <!-- Input groups -->
          <div :class="`${'card-shadow dashboard-card p-4 md:mb-24'} `">
            <!-- State of residence, loan type/amount, and loan reason -->
            <div v-if="getBorrowerStep === 'loanDetails'">
              <LoanDetails
                @updateData="updateLoanDetails"
                @next="next('personalInformation')"
                @back="handlePreviousStepRouting('chooseEmployer')"
              />
            </div>

            <div v-if="getBorrowerStep === 'chooseEmployer'">
              <ChooseEmployer @next="next" />
            </div>

            <div v-else-if="getBorrowerStep === 'authPrequal'">
              <AuthPrequal
                :update="updateFinished"
                @next="checkRate"
                @back="handlePreviousStepRouting('employmentInformation')"
              />
            </div>

            <div v-else-if="getBorrowerStep === 'prequalApprove'">
              <PrequalApprove
                @next="next('consentPage')"
                @back="handlePreviousStepRouting('authPrequal')"
              />
            </div>
            <div v-else-if="getBorrowerStep === 'prequalRej'">
              <PrequalRej @next="next('consentPage')" @denial="predeny" @back="routeToHome" />
            </div>

            <div v-else-if="getBorrowerStep === 'personalInformation'">
              <PersonalInformation
                @updateData="updatePersonalInformation"
                @next="next('employmentInformation')"
                @back="handlePreviousStepRouting('loanDetails')"
              />
            </div>

            <div v-else-if="getBorrowerStep === 'employmentInformation'">
              <EmploymentInformation
                @updateData="updateEmploymentInformation"
                @next="next"
                @back="handlePreviousStepRouting('personalInformation')"
              />
            </div>

            <div v-else-if="getBorrowerStep === 'pinwheelIE'">
              <Pinwheel
                @next="next('consentPage')"
                @back="handlePreviousStepRouting('employmentInformation')"
              />
            </div>

            <div v-else-if="getBorrowerStep === 'consentPage'">
              <PlaidDwollaCreditConsent
                @next="next"
                @back="handlePreviousStepRouting('employmentInformation')"
              />
            </div>
            <div v-else-if="getBorrowerStep === 'fundingAccount'">
              <FundingAccount
                @next="fundingAccountNext"
                @back="handlePreviousStepRouting('consentPage')"
              />
            </div>
            <div v-else-if="getBorrowerStep === 'uploadIdentity'">
              <FileDrop categoryProp="identity" @next="uploadIdentityNext" />
            </div>
            <div v-else-if="getBorrowerStep === 'uploadPaystubs'">
              <FileDrop :maxFileSize="10485760" categoryProp="paystubs" @next="checkTenure" />
            </div>
            <div v-else-if="getBorrowerStep === 'uploadTenure'">
              <FileDrop categoryProp="tenure" @next="requestTenureNext" />
            </div>
            <div v-else-if="getBorrowerStep === 'verifyMD'">
              <VerifyMicroDeposits @next="verifyMDNext" />
            </div>
            <div v-else-if="getBorrowerStep === 'completeUnderReview'">
              <CompleteAndUnderReview />
            </div>
            <div v-else-if="getBorrowerStep === 'rejected'">
              <Restriced />
            </div>
            <div
              v-else-if="
                this.$store.getters.applicationStep === 'Offer Sent' &&
                (this.$store.getters.offerStage === 'Offer Sent' ||
                  this.$store.getters.offerStage === 'Pinwheel Initiated')
              "
            >
              <OfferDetails />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrequalApprove from '@/components/ApplicationFlow/PrequalApprove'
import PrequalRej from '@/components/ApplicationFlow/PrequalRej'
import AuthPrequal from '@/components/ApplicationFlow/AuthPrequal'
import PlaidDwollaCreditConsent from '@/components/ApplicationFlow/PlaidDwollaCreditConsent'
import FundingAccount from '@/components/ApplicationFlow/FundingAccount'
import VerifyMicroDeposits from '@/components/ApplicationFlow/VerifyMicroDeposits'
import FileDrop from '@/components/VIVA/FileDrop'
import LoanDetails from '@/components/ApplicationFlow/LoanDetails'
import ChooseEmployer from '@/components/ApplicationFlow/ChooseEmployer'
import PersonalInformation from '@/components/ApplicationFlow/PersonalInformation'
import EmploymentInformation from '@/components/ApplicationFlow/EmploymentInformation'
import CompleteAndUnderReview from '@/components/ApplicationFlow/CompleteAndUnderReview'
import OfferDetails from '@/components/ApplicationFlow/OfferDetails'
import Pinwheel from '@/components/ApplicationFlow/Pinwheel'
import Restriced from '@/views/Pages/Restricted'
import Engine from '@/mixins/Engine'
import { v4 as uuidv4 } from 'uuid'
import modelEstimate from '@/mixins/modelEstimate.js'

export default {
  name: 'Apply',
  mixins: [Engine],
  components: {
    PrequalApprove,
    PrequalRej,
    AuthPrequal,
    LoanDetails,
    PersonalInformation,
    PlaidDwollaCreditConsent,
    VerifyMicroDeposits,
    FundingAccount,
    EmploymentInformation,
    CompleteAndUnderReview,
    OfferDetails,
    FileDrop,
    Restriced,
    Pinwheel,
    ChooseEmployer
  },

  data: function () {
    return {
      applicationStepRoute: null,
      pageProgress: {
        chooseEmployer: 9,
        loanDetails: 18,
        personalInformation: 27,
        employmentInformation: 36,
        pinwheelIE: 45,
        consentPage: 54,
        fundingAccount: 63,
        uploadPaystubs: 72,
        uploadTenure: 81,
        verifyMD: 90,
        completeUnderReview: 100
      },
      preRejection: false,
      updateFinished: false
    }
  },

  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // react to route changes...
        this.applicationStepRoute = toParams.applicationStep
      }
    )
  },
  mounted() {
    this.applicationStepRoute = this.$route.params.applicationStep
    if (this.$gtm.enabled() && window.dataLayer) {
      window.dataLayer.push({
        event: 'loadApplication',
        stage: this.$store.getters.isProduction ? 'production' : 'dev',
        username: this.$store.getters.username
      })
    }
  },
  computed: {
    preRejcted() {
      if (this.$store.getters.preQualificationFailureReason.length > 0) {
        return true
      } else {
        return false
      }
    },
    getBorrowerStep() {
      //If the user reaches the page from the /apply route alone
      //Get the step from the store
      let borrowerApplicationStep = this.$store.state.applicationData.step
      console.log(borrowerApplicationStep)
      if (!this.applicationStepRoute) {
        return borrowerApplicationStep
      } else {
        /*
        If a route is provided, then this route has already been
        vetted and verified that it is allowed, using the routing
        config. See main.js.
        */
        return this.applicationStepRoute
      }
    },
    activeFS() {
      // read from store, get the account id and filter on funding sources to get the object
      return this.$store.getters.activeFundingSource
    },

    successfulPinwheelIE() {
      return this.$store.getters.successfulPinwheelIE
    },
    autoRequestIdentity() {
      return this.$store.getters.autoRequestIdentity
    }
  },
  methods: {
    routeToHome() {
      window.location.href = 'https://www.viva-finance.com'
    },

    updateLoanDetails(d) {
      this.$store.commit('applicationData/updateLoanDetails', d)
      this.$store.dispatch('applicationData/uploadLoanDetails', d).catch((e) => {
        console.log(`FE Error in apply/updateLoanDetails: ${e}`)
        console.warn(e)
      })
    },
    // TODO: Check if below is used
    updatePersonalInformation(d) {
      this.$store.commit('applicationData/updatePersonalInformation', d)
      const personalObject = { d: d, accountSettings: false }
      this.$store
        .dispatch('applicationData/uploadPersonalInformation', personalObject)
        .catch((e) => {
          console.log(`FE Error in apply/updatePersonalInformation: ${e}`)
          console.warn(e)
        })
    },
    fundingAccountNext() {
      if (this.autoRequestIdentity) {
        this.next('uploadIdentity')
      } else if (this.activeFS.link_type === 'plaid_getAuth') {
        this.checkTenure()
      } else {
        this.next('uploadPaystubs')
      }
    },
    uploadIdentityNext() {
      if (this.activeFS.link_type === 'plaid_getAuth') {
        this.checkTenure()
      } else {
        this.next('uploadPaystubs')
      }
    },
    checkRate(qualified) {
      console.log(`!!!${qualified}`)
      if (qualified) {
        this.next('prequalApprove')
      } else {
        this.next('prequalRej')
      }
    },
    checkTenure() {
      console.log('Checking Tenure')
      // If tenure not needed, then finish the app
      if (
        this.$store.state.applicationData.tenureProof === 'NoVerificationDocsNeeded' ||
        this.$store.state.applicationData.tenureDocOnFile
      ) {
        if (this.activeFS.link_type === 'dwolla_MicroDeposits' && !this.activeFS.verified) {
          // if FS is MD, must verify it
          this.next('verifyMD')
        } else {
          // if tenure not needed and FS was plaid, then nothing more is needed
          this.next('completeUnderReview')
        }
      } else {
        // If tenure verification is needed, request docs
        if (this.successfulPinwheelIE) {
          this.next('completeUnderReview')
        } else {
          this.next('uploadTenure')
        }
      }
    },
    requestTenureNext() {
      if (this.activeFS.link_type === 'dwolla_MicroDeposits' && !this.activeFS.verified) {
        // check if active funding source is unverified
        this.next('verifyMD')
      } else {
        this.next('completeUnderReview')
      }
    },
    verifyMDNext() {
      this.next('completeUnderReview')
    },
    predeny(reason) {
      this.$store.commit('applicationData/setRejectionReason', reason)
    },
    next(nextStep) {
      // Todo: Mahmoud: commit state to be rejected so
      // FE doesn't have to wait for loadFrontend call
      if (nextStep === 'denied') {
        this.$store.commit('applicationData/updateApplicationStepForRejection', 'rejected')
        this.$router.push({
          path: '/not-approved'
        })
        return
      }
      if (nextStep.includes('applicationBlocked')) {
        this.$store.commit('applicationData/updateApplicationStepForRejection', nextStep)
        this.$router.push({
          path: nextStep.toLowerCase().includes('ner') ? '/nersubmitted' : '/applicationBlocked'
        })
        return
      }
      if (nextStep === 'completeUnderReview') {
        if (this.$gtm.enabled() && window.dataLayer) {
          const type = 'applied'
          const id = uuidv4()
          window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
          this.pushGtmData()
          window.dataLayer.push({
            ecommerce: {
              add: {
                products: [
                  {
                    name: `Lifestyle Loan`,
                    id,
                    price: this.$store.getters.preQualifiedAmount,
                    category: 'Lending'
                  }
                ]
              }
            }
          })
          window.dataLayer.push({
            event: 'completeApplication',
            stage: this.$store.getters.isProduction ? 'production' : 'dev',
            username: this.$store.getters.username,
            completeApplicationValue: this.$store.getters.preQualifiedAmount,
            firstName: this.$store.getters.firstName,
            lastName: this.$store.getters.lastName,
            phoneNumber: this.$store.getters.phoneNumber,
            addrCountry: this.$store.getters.addrCountry,
            addrPostalCode: this.$store.getters.addrPostalCode,
            id
          })
          this.$store.dispatch('applicationData/setGtmEcommerceId', { type, id }).catch((e) => {
            console.log(e)
            console.log(`FE Error in apply/setGtmEcommerceId: ${e}`)
          })
        }
      }
      this.$store.commit('applicationData/sessionPush', nextStep)
      this.$store.dispatch('applicationData/setDatabaseApplicationStep', nextStep).catch((e) => {
        console.log(e)
        console.log(`FE Error in apply/setDatabaseApplicationStep: ${e}`)
      })
      console.log(`/apply/${nextStep}`)
      this.$router.push({
        path: `/apply/${nextStep}`
      })
    },
    back() {
      this.$store.commit('applicationData/sessionPop')
    },
    pushGtmData() {
      window.dataLayer.push({
        firstName: this.$store.getters.firstName,
        lastName: this.$store.getters.lastName,
        phoneNumber: this.$store.getters.phoneNumber,
        homePhone: this.$store.state.applicationData.home_phone_number,
        personalEmail: this.$store.state.applicationData.personal_email,
        addrCountry: this.$store.state.applicationData.country,
        addrPostalCode: this.$store.state.applicationData.postalCode
      })
    },
    handlePreviousStepRouting(toRoute) {
      this.$store.state.applicationData.step = toRoute
      this.$router.push({
        path: `/apply/${toRoute}`
      })
    }
  }
}
</script>
